// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2276":"f3d27742","2673":"f93f1e5d","3637":"6a1c0c61","5604":"3f8aa8a4","7805":"3b55b41e","9965":"478c86ab"}[chunkId] + ".chunk.css";
};